module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flex flex-wrap mb4",
    attrs: {
      "id": "problem-description"
    }
  }, [_c('div', {
    staticClass: "descr-image-wrapper lg-col-6 col-12 image0",
    attrs: {
      "id": "descr-image-wrapper"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "descr-block lg-col-6 col-12 flex flex-column justify-between"
  }, [_vm._l((_vm.content.tabs), function(tab) {
    return (tab.show) ? _c('article', {
      key: tab.id,
      staticClass: "pt3 pl3 pr3"
    }, [_c('h1', {
      staticClass: "h2 m0",
      domProps: {
        "innerHTML": _vm._s(tab.title)
      }
    }), _vm._v(" "), _vm._l((tab.paragraphs), function(p) {
      return _c('p', {
        key: p.id,
        domProps: {
          "innerHTML": _vm._s(p.text)
        }
      })
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('nav', {
    staticClass: "flex bold px3 pb2"
  }, _vm._l((_vm.content.tabs), function(t) {
    return _c('a', {
      key: t.id,
      class: t.className,
      attrs: {
        "href": '#' + t.name
      },
      on: {
        "click": function($event) {
          return _vm.showTab($event, t.id, _vm.content.tabs)
        }
      }
    }, [_vm._v("—")])
  }), 0)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef7b498","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProblemDescription.vue
// module id = 118
// module chunks = 0